import { useGet, usePost } from "src/http-clients/clients";

export const useGetTax = () => {
  const data = useGet(`/users/vendor/taxes`);
  return data;
};

export const useCreateTax = () => {
  return usePost(`/users/vendor/taxes`);
};
